
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightLanternPortColourOn as ObiLightLanternPortColourOnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-light-lantern-port-colour-on.js';
 
 
 

 
 export const ObiLightLanternPortColourOn = createComponent({
   react: React,
   tagName: 'obi-light-lantern-port-colour-on',
   elementClass: ObiLightLanternPortColourOnElement,
   events: {
     
   }
  });
 
 